import { render, staticRenderFns } from "./QRScannerComponent.vue?vue&type=template&id=42a36b78"
import script from "./QRScannerComponent.vue?vue&type=script&lang=js"
export * from "./QRScannerComponent.vue?vue&type=script&lang=js"
import style0 from "./QRScannerComponent.vue?vue&type=style&index=0&id=42a36b78&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports